import type { TeoPDF } from '@/utils/teo-pdf/TeoPDF';

import tcllogo from './assets/tcl-logo.png?inline';
import teologo from './assets/teo-logo.png?inline';

const tcllogoSize = { w: 1397, h: 1280 };
const teologoSize = { w: 276, h: 117 };
const TEO_LOGO_WIDTH = 64;
const TCL_LOGO_WIDTH = 38;
const TCL_LOGO_HEIGHT = (TCL_LOGO_WIDTH * tcllogoSize.h) / tcllogoSize.w;
const TEO_LOGO_HEIGHT = (TEO_LOGO_WIDTH * teologoSize.h) / teologoSize.w;
const HEADER_FOOTER_MARGIN = 16;
export const FOOTER_HEIGHT = Math.max(TEO_LOGO_HEIGHT, TCL_LOGO_HEIGHT) + HEADER_FOOTER_MARGIN;

export function createPageElementsRenderer({
  createdAt,
  reportId,
  title,
}: {
  createdAt: number;
  reportId: string;
  title: string;
}) {
  return {
    renderFooter: (pdf: TeoPDF) => {
      const origin = pdf.position;
      const { pageHeight, width, x } = pdf.getPageBounds();

      pdf
        .addImage(
          teologo,
          { x, y: pageHeight - TEO_LOGO_HEIGHT - HEADER_FOOTER_MARGIN },
          { width: TEO_LOGO_WIDTH },
        )
        .addImage(
          tcllogo,
          {
            x: x + width - TCL_LOGO_WIDTH,
            y: pageHeight - TCL_LOGO_HEIGHT - HEADER_FOOTER_MARGIN,
          },
          { width: TCL_LOGO_WIDTH },
        )
        .moveTo(origin);
    },
    renderHeader: (pdf: TeoPDF) => {
      const origPos = pdf.position;

      pdf
        .addText(`Report: ${title} (ID: ${reportId})`, {
          pos: { x: pdf.getPageBounds().x, y: HEADER_FOOTER_MARGIN },
          size: 10,
          align: 'left',
        })
        .addText(new Date(createdAt).toLocaleString(), {
          pos: { x: pdf.getPageBounds().x, y: HEADER_FOOTER_MARGIN },
          size: 10,
          align: 'right',
        });
      pdf.moveTo(origPos);
      pdf.moveDown(1);
    },
  };
}
